import type { TestConceptGroup } from "@/generated/sdk"

export const testConceptHasNoValueColumn = (testConcept: TestConceptGroup): boolean =>
  testConcept.valueColumns.length === 0

// Set by extraction (test_concept_finalizer.AUTO_REPAIRED_GROUP_NAME) on a group
// it gave a value column to and disabled. Such a group needs a DAE's review, so
// it must not be enabled in bulk.
export const AUTO_REPAIRED_GROUP_NAME = "Auto-repaired test list - review before enabling"

export const isAutoRepaired = (testConcept: TestConceptGroup): boolean =>
  testConcept.name === AUTO_REPAIRED_GROUP_NAME

// Same identifier rule as common/column_identifier.py: the generator skips a
// group whose column names it cannot safely interpolate into SQL.
const VALID_COLUMN = /^[A-Za-z_][A-Za-z0-9_]*$/

// Why the DQ rule generator emits no rule for this group, or null when it does.
// Covers the skip conditions in rule_generator_test_concept.py that a group
// can reach in the editor.
export const noRuleReason = (testConcept: TestConceptGroup): string | null => {
  if (testConcept.enabled === false) return "the test concept is disabled"
  if (testConcept.conditionColumns.length === 0) return "it has no condition columns"
  if (testConcept.valueColumns.length === 0) return "it has no value columns"
  const invalid = [
    ...testConcept.conditionColumns,
    ...testConcept.valueColumns,
    ...(testConcept.instrument_column ?? []),
  ].filter((col) => !VALID_COLUMN.test(col))
  if (invalid.length > 0) {
    return `column names are not valid identifiers (${invalid.join(", ")})`
  }
  return null
}
